import React from "react";
import { iconProps } from "../../../Helper";

export const SummarizeIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask
        id="mask0_8637_86021"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8637_86021)">
        <path
          className={className}
          d="M9.6665 11.7563V10.7565H2.33317V11.7563H9.6665ZM9.6665 8.49999V7.49999H2.33317V8.49999H9.6665ZM13.6665 5.24349V4.24365H2.33317V5.24349H13.6665Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
